const NewProductTypes = {
  ADD_NEW_PRODUCT_START: 'ADD_NEW_PRODUCT_START',
  ADD_NEW_PRODUCT_FAILURE: 'ADD_NEW_PRODUCT_FAILURE',
  ADD_NEW_PRODUCT_SUCCESS: 'ADD_NEW_PRODUCT_SUCCESS',
  CLEAR_REDUX_STATE: 'CLEAR_REDUX_STATE',
};

export default NewProductTypes;
